const CATEGORIES = [
    {
        title: 'Оружие',
        link: '/weapons',
        subCategories: [{ title: 'Нарезное', link: '/rifles' }, 
                        { title: 'Гладкоствольное', link: '/shotguns' }, 
                        { title: 'Пневматическое', link: '/pneumatic' }, 
                        { title: 'Травматическое', link: '/traumatic' },],
    },
    {
        title: 'Средства защиты',
        link: '/protection',
        subCategories: [{ title: 'Перцовые балончики', link: '/pepper_sprays' }, 
                        { title: 'Электрошокеры', link: '/stun_guns' }, 
                        { title: 'Остальное', link: '/rest_protection' },],
    },
    {
        title: 'Ножи',
        link: '/knives',
    },
    {
        title: 'Боеприпасы',
        link: '/ammunition',
        subCategories: [{ title: 'Для нарезного оружия',link: '/for_rifles' }, 
                        { title: 'Для гладкоствольного оружия',link: '/for_shotguns' }, 
                        { title: 'Для пневматического оружия',link: '/for_pneumatic' }, 
                        { title: 'Для травматического оружия',link: '/for_traumatic' },],
    },
    {
        title: 'Одежда и обувь',
        link: '/clothes',
    },
    {
        title: 'Оптика',
        link: '/gunsights',
        subCategories: [{ title: 'Оптические прицелы', link: '/optical_sights' }, 
                        { title: 'Коллиматорные прицелы', link: '/collimator_sights' },
                        { title: 'Тепловизионные прицелы', link: '/thermal_sights' },
                        { title: 'Приборы ночного видения', link: '/night_vision_devices' },
                        { title: 'Дальномеры', link: '/rangefinders' },
                        { title: 'Бинокли', link: '/binoculars' }],
    },
    {
        title: 'Аксессуары',
        link: '/accessories',
        subCategories: [{ title: 'Сошки',link: '/bipods' }, 
                        { title: 'Уход за оружием',link: '/gun_care' }, 
                        { title: 'Чехлы' ,link: '/gun_cases'}, 
                        { title: 'Ремни' ,link: '/belts'}, 
                        { title: 'Инструменты',link: '/special_tools' }, 
                        { title: 'Капканы',link: '/traps' }, 
                        { title: 'Чучела животных',link: '/stuffed_animals' }, 
                        { title: 'Наушники и очки',link: '/headphones_glasses' }, 
                        { title: 'Остальное',link: '/rest_accessories' }],
    },
]

export default CATEGORIES;